
export abstract class Predicate<T> {
  abstract match(object:T):boolean;
  abstract message():string;
}